import { getError } from "@/utils/helpers";
import OrderService from "@/services/OrderService";

export const namespaced = true;

function setOrders(commit, response) {
  commit("SET_ORDERS", response.data);
  commit("SET_LOADING", false);
}

export const state = {
  orders: [],
  loading: false,
  error: null
};

export const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export const actions = {
  getOrders({ commit }) {
    commit("SET_LOADING", true);
    OrderService.getOrders()
      .then(response => {
        setOrders(commit, response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      });
  }
};

export const getters = {
  orders: state => {
    return state.orders;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  }
};
